export const getStates = state => state.states;
export const getModalListCRCActivated = state => state.modalListCRCActivated;
